export default __webpack_public_path__ + "static/media/icon.3ddce424.png";